<template>
  <div>
    <h1 class="center">NOTICIAS Y NOVEDADES</h1>
    <h3 class="center">Conoce nuestros eventos mas importantes</h3>
    <v-container style="">
      <div :style="{ width: !$vuetify.breakpoint.smAndDown ? '70%' : '100%' }">
        <v-btn :color="$ajustes.colorCabecera" style="color: white;"
          @click="nuevoNoticia = true; formularioDialogo = true">NUEVA
          NOTICIA</v-btn>
        <v-btn class="ml-3" :color="$ajustes.colorCabecera" style="color: white;"
          @click="obtenerNoticias()"><v-icon>mdi-refresh</v-icon></v-btn>
      </div>
      <br>
      <v-card elevation="0" class="pa-1 pl-4 mb-3" :style="{ border: '1px solid ' + $ajustes.colorCabecera }"
        v-for="noticia in noticias" :key="noticia.id">
        <div style="display: flex;">
          <h3 style="text-align: left;">Fecha Noticia: <span style="font-weight: normal;"> {{ noticia.fecha_noticia
          }}</span></h3>
          <v-spacer></v-spacer>
          <div style="float: right;">
            <span class="ma-1 pointer" :style="{ fontWeight: noticia.destacado == 1 ? 'bold' : null }"
              @click="estadoNoticia(noticia.id, 'destacado', noticia.destacado == 0 ? 1 : 0)">DESTACADO</span>
            <span class="ma-1 pointer" :style="{ fontWeight: noticia.habilitado == 1 ? 'bold' : null }"
              @click="estadoNoticia(noticia.id, 'habilitado', noticia.habilitado == 0 ? 1 : 0)">HABILITADO</span>
            <span class="ma-1 pointer" @click="noticiaDatos = noticia; visualizarDialogo = true">VER</span>
            <span class="ma-1 pointer"
              @click="nuevoNoticia = false; noticiaDatos = noticia; formularioDialogo = true">EDITAR</span>
            <span class="ma-1 pointer" @click="eliminarNoticia(noticia.id)">ELIMINAR</span>
          </div>
        </div>
        <h2 style="text-align: left;"><v-icon v-if="noticia.destacado == 1" class="mb-1 mr-1" color="gold" small>mdi-star-circle</v-icon>{{ noticia.titulo }}
        </h2>
      </v-card>
    </v-container>
    <formulario :propCrear="axios.crearNoticia" :propActualizar="axios.actualizarNoticia" :propNuevo="nuevoNoticia"
      :propNoticia="noticiaDatos" :propDialogo="formularioDialogo"
      @closeDialogo=" obtenerNoticias(); formularioDialogo = false" />
    <visualizar :propNoticia="noticiaDatos" :propDialogo="visualizarDialogo"
      @closeDialogo="noticiaDatos={};visualizarDialogo = false" />
  </div>
</template>
<script>
import * as axios from "./axios";
import formulario from "./formulario";
import visualizar from "./visualizar";

export default {
  components: {
    formulario,
    visualizar
  },
  data() {
    return {
      formularioDialogo: false,
      visualizarDialogo: false,
      nuevoNoticia: true,
      noticiaDatos: {},
      noticias: [],
      axios
    };
  },
  mounted() {
    this.obtenerNoticias()
  },

  created() { },
  computed: {},
  methods: {
    async obtenerNoticias() {
      this.noticias = []
      var response = await axios.obtenerNoticias()
      this.noticias = response.data
    },
    async estadoNoticia(_id, _campo, _estado) {
      const noticia = {
        id: _id,
        campo: _campo,
        estado: _estado,
      }
      await axios.estadoNoticia(noticia)
      this.obtenerNoticias()
    },
    async eliminarNoticia(noticiaId) {
      await axios.eliminarNoticia(noticiaId)
      this.obtenerNoticias()
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
